import { render, staticRenderFns } from "./zhanbi.vue?vue&type=template&id=3edb71a3&scoped=true&"
import script from "./zhanbi.vue?vue&type=script&lang=js&"
export * from "./zhanbi.vue?vue&type=script&lang=js&"
import style0 from "./zhanbi.vue?vue&type=style&index=0&id=3edb71a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb71a3",
  null
  
)

export default component.exports